import { IBienLaiChangeChoPhepXuatHDRequest } from "../../../model/request/bien-lai/IBienLaiChangeChoPhepXuatHDRequest";
import { IBienLaiHuyRequest } from "../../../model/request/bien-lai/IBienLaiHuyRequest";
import { IBienLaiPagingRequest } from "../../../model/request/bien-lai/IBienLaiPagingRequest";
import { IBienLaiSaveImportRequest } from "../../../model/request/bien-lai/IBienLaiSaveImportRequest";
import { IBienLaiSyncKeToanRequest } from "../../../model/request/bien-lai/IBienLaiSyncKeToanRequest";
import { IBienLaiThu } from "../../../model/respone/bien-lai/IBienLaiThu";
import {
  IBienLaiThuPaging,
  IPagingBienLaiResult,
} from "../../../model/respone/bien-lai/IBienLaiThuPaging";
import { IMucThuImportBoundResponse } from "../../../model/respone/chung-tu/IMucThuImportResponse";
import { IPagingResult } from "../../../model/respone/IPagingResult";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBienLaiPagingBaseActionTypes<T> {
  request: number;
  data: T;
}
export const eBienLaiPagingActionsObj = {
  LOAD_START: {} as IBienLaiPagingRequest,
  LOAD_SUCCESS: {} as IPagingBienLaiResult,
  LOAD_ERRR: {} as string,

  CHANGE_REQUEST: {} as any,
  SHOW_DETAIL_MODAL: 0,
  HIDE_DETAIL_MODAL: undefined,

  SHOW_HUY_MODAL: {} as IBienLaiThuPaging,
  HIDE_HUY_MODAL: undefined,

  SHOW_HIDE_FILTER: {} as boolean,

  HUY_START: {} as IBienLaiHuyRequest,
  HUY_SUCCESS: {} as IBienLaiThu,
  HUY_ERRR: "",

  EXPORT_EXCEL_BAO_CAO_START: {} as IBienLaiPagingRequest,
  EXPORT_EXCEL_BAO_CAO_SUCCESS: "",
  EXPORT_EXCEL_BAO_CAO_ERRR: "",

  PRINT_BAO_CAO_START: {} as IBienLaiPagingRequest,
  PRINT_BAO_CAO_SUCCESS: "",
  PRINT_BAO_CAO_ERRR: "",
  PRINT_BAO_CAO_CLOSE: undefined,

  CHANGE_CHO_PHEP_XUAT_HD_START: {} as IBienLaiChangeChoPhepXuatHDRequest,
  CHANGE_CHO_PHEP_XUAT_HD_SUCCESS: {} as IBienLaiChangeChoPhepXuatHDRequest,
  CHANGE_CHO_PHEP_XUAT_HD_ERRR: "",

  SELECTED_ID: [] as number[],
  SHOWHIDE_DONG_BO_KE_TOAN_MODAL: false,

  SHOW_HIDE_IMPORT_MODAL: false,
  IMPORT_START: {} as FormData,
  IMPORT_SUCESS: {} as IMucThuImportBoundResponse,
  IMPORT_ERROR: "",
  SAVE_IMPORT_START: {} as IBienLaiSaveImportRequest,
  SAVE_IMPORT_SUCESS: undefined,
  SAVE_IMPORT_ERROR: "",
  HIDE_IMPORT_RESULT_MODAL: undefined,
  SYNC_KE_TOAN_START: {} as IBienLaiSyncKeToanRequest,
  SYNC_KE_TOAN_FAKE_START: {} as IBienLaiSyncKeToanRequest,
  SYNC_KE_TOAN_SUCCESS: undefined,
  SYNC_KE_TOAN_ERRR: {} as string,
};
export const eBienLaiPagingActionTypeIds = generateActionTypeIds(
  eBienLaiPagingActionsObj,
  "BIEN_LAI_PAGING",
);
export type IBienLaiPagingActionTypes = IGenericActionType<
  typeof eBienLaiPagingActionsObj,
  "BIEN_LAI_PAGING"
>;
